import React, { useState,useMemo  } from "react";
import { Trash2 } from "lucide-react";

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const Warmup = () => {
  const [responseMessage, setResponseMessage] = useState("");
  const [selectedTables, setSelectedTables] = useState([]);
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mergeLoading, setMergeLoading] = useState(false);
  const [groupCounts, setGroupCounts] = useState({});
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState("");
  const [emailGroups, setEmailGroups] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [newTableName, setNewTableName] = useState("");
  const [total, setTotal] = useState(0);
  const [mergeTableName, setMergeTableName] = useState("");


React.useEffect(() => {
  const sum = Object.values(quantities).reduce(
    (acc, val) => acc + (parseInt(val) || 0),
    0
  );
  setTotal(sum);
}, [quantities]);

// 📊 Fetch warmup count on page load
React.useEffect(() => {
const date = new Date();
const month = date.toLocaleString("en-US", { month: "short" }).toLowerCase();
const day = date.getDate();
  setNewTableName(`warmup_${month}${day}`);
  const fetchWarmupCount = async () => {
    try {
      const response = await fetch("https://utilities.livauto.com/api/getwarmup_count", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ db: "aaaaall_temp" }),
      });
      const data = await response.json();
      setTables(data);
    } catch (error) {
      console.error("Error fetching warmup count:", error);
    }
  };
  fetchWarmupCount();
}, []);


  // 📋 Fetch email groups when table is selected
  const handleTableChange = async (e) => {
    const table = e.target.value;
    setSelectedTable(table);
    setEmailGroups([]);
    setQuantities({});
    setEmails([]);
    setGroupCounts({});
    
    if (!table) return;

    try {
      const response = await fetch(
        "https://utilities.livauto.com/api/getwarmup_emailgroup",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ db: "aaaaall_temp", table }),
        }
      );
      const groups = await response.json();
      setEmailGroups(groups);
      
      // Initialize quantities to 0
      const initialQuantities = {};
      groups.forEach((group) => {
        initialQuantities[group.EmailDomainGroup] = 0;
      });
      setQuantities(initialQuantities);
    } catch (error) {
      console.error("Error fetching email groups:", error);
      alert("❌ Failed to fetch email groups.");
    }
  };

  // Update quantity for a specific group
const handleQuantityChange = (group, value) => {
  const numValue = parseInt(value) || 0;
  setQuantities((prev) => ({
    ...prev,
    [group]: numValue,
  }));
};


  // 🚀 Process Button
  const handleProcess = async () => {
    if (!selectedTable || Object.keys(quantities).length === 0) {
      alert("⚠️ Please select a table and fill quantities.");
      return;
    }

    // Filter out groups with 0 quantity and create array of objects
    const domainsArray = Object.entries(quantities)
      .filter(([_, qty]) => qty > 0)
      .map(([domain, quantity]) => ({
        domain: domain,
        quantity: quantity
      }));

    if (domainsArray.length === 0) {
      alert("⚠️ Please enter at least one quantity greater than 0.");
      return;
    }

    setLoading(true);
    setEmails([]);

    const payload = {
      domains: domainsArray,
      db: "aaaaall_temp",
      table: selectedTable,
    };

    console.log("📦 Payload:", JSON.stringify(payload, null, 2));

    try {
      const response = await fetch(
        "https://utilities.livauto.com/api/getemailsbydomain",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();

      // 🧩 handle nested array (response[0])
      const emailList = Array.isArray(data) && Array.isArray(data[0])
        ? data[0]
        : data;

      console.log(emailList);
      setEmails(emailList);

      const counts = {};
      emailList.forEach((item) => {
        const group = item.EmailGroup || "Unknown";
        counts[group] = (counts[group] || 0) + 1;
      });
      setGroupCounts(counts);

    } catch (error) {
      console.error("Error fetching emails:", error);
      alert("❌ Failed to process. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  // 💾 Download CSV + Call Delete API
  const handleDownloadCSV = async () => {
    if (!emails.length) return;

    // Get headers
    const headers = Object.keys(emails[0]).join(",");

    // Convert rows
    const rows = emails.map((obj) =>
      Object.values(obj)
        .map((value) => `"${value ? value.toString().replace(/"/g, '""') : ""}"`)
        .join(",")
    );

    const csvContent = [headers, ...rows].join("\n");

    // Create blob for download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = newTableName+".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // 📨 Extract only emails as an array of strings
    const emailList = emails
      .map((item) => item.Email || item.email || item.EMAIL)
      .filter((email) => !!email);

    if (emailList.length === 0) {
      console.warn("⚠️ No email column found in data.");
      return;
    }

    // 📤 Call delete API
    const deletePayload = {
      db: "aaaaall_temp",
      table: selectedTable,
      emails: emailList,
      newtable: newTableName
    };

    try {
      console.log("🗑️ Sending delete request:", deletePayload);
      const response = await fetch(
        "https://utilities.livauto.com/api/deleteemailsbydomain",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(deletePayload),
        }
      );
      const data = await response.json();

      console.log("Delete API response:", data);
    } catch (err) {
      console.error("❌ Error calling delete API:", err);
      alert("⚠️ CSV downloaded but failed to delete emails from database.");
    }
  };

  const handleMerge = async () => {
    if (!mergeTableName || selectedTables.length < 2) {
      alert("Please enter a table name and select at least one table.");
      return;
    }
    try {
      setMergeLoading(true); 
      const name = `[aaaaall_temp].[dbo].[${mergeTableName}]`;
      const res = await fetch("https://utilities.livauto.com/api/mergetables", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tableName: name,
          tables: selectedTables
        })
      });
      const data = await res.json();
      console.log("Merge response:", data);
      if (data.status === "1") {
        setResponseMessage(data.message); // save success message
        setTimeout(() => {
          window.location.reload(); // reload page after 2 seconds
        }, 2000);
      } else {
        setMergeLoading(false); 
        setResponseMessage(data.error); // save error message
      }
    } catch (err) {
      setMergeLoading(false); 
      console.log(err.message);
    }
  };

  const columnsArr = useMemo(() => {
    const uniqueDomains = new Set();
    tables.forEach(table => {
      if (table.EmailGroups) {
        table.EmailGroups.forEach(group => {
          uniqueDomains.add(group.EmailDomainGroup);
        });
      }
    });
    return Array.from(uniqueDomains).sort();
  }, [tables]);

  // Get count for a specific domain in a table
  const getDomainCount = (table, domain) => {
    if (!table.EmailGroups) return 0;
    const group = table.EmailGroups.find(g => g.EmailDomainGroup === domain);
    return group ? group.Count : 0;
  };
  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>Warmup</h2>


      {selectedTables.length > 0 && (
<div style={{ marginTop: "20px" }}>
  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <input
      type="text"
      placeholder="Enter merged table name"
      value={mergeTableName}
      onChange={(e) => setMergeTableName(e.target.value)}
      style={{
        width: "30%",
        padding: "8px 12px",
        fontSize: "14px",
        borderRadius: "6px",
        border: "1px solid #d1d5db"
      }}
    />

    {selectedTables.length > 0 && (
      <button
        onClick={handleMerge}
        disabled={mergeLoading}
        style={{
          padding: "8px 16px",
          fontSize: "14px",
          fontWeight: "600",
          borderRadius: "8px",
          border: "1px solid #d1d5db",
          cursor: "pointer",
          backgroundColor: "#3b82f6",
          color: "#fff",
          transition: "all 0.2s ease"
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563eb")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3b82f6")}
      >
        Merge
      </button>
    )}
  </div>

  {/* Response message on a new line */}
  {responseMessage && (
    <div style={{ marginTop: "10px" }}>
      <p>{responseMessage}</p>
    </div>
  )}
</div>

      )}
<br/>
<br/>

<div style={{ width: "100%", overflowX: "auto" }}>
      <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid #ccc",
            backgroundColor: "white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#4a90e2", color: "white" }}>
			<th style={{ 
                border: "1px solid #ccc", 
                padding: "12px", 
                textAlign: "left",
                fontWeight: "600"
              }}>
              </th>
              <th style={{ 
                border: "1px solid #ccc", 
                padding: "12px", 
                textAlign: "left",
                fontWeight: "600"
              }}>
                Table Name
              </th>
              <th style={{ 
                border: "1px solid #ccc", 
                padding: "12px", 
                textAlign: "right",
                fontWeight: "600"
              }}>
                Record Count
              </th>
              {columnsArr.map((domain, index) => (
                <th 
                  key={index}
                  style={{ 
                    border: "1px solid #ccc", 
                    padding: "12px", 
                    textAlign: "right",
                    fontWeight: "600"
                  }}
                >
                  {domain}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tables.map((table, tableIndex) => (
              <tr 
                key={tableIndex}
                style={{ 
                  backgroundColor: tableIndex % 2 === 0 ? "#f9f9f9" : "white"
                }}
              >
              
              <td style={{
  border: "1px solid #ccc",
  padding: "10px",
  fontWeight: "500",
  display: "flex",
  alignItems: "center",
  gap: "12px"
}}>

<input
    type="checkbox"
    onChange={e => {
      const name = `[aaaaall_temp].[dbo].[${table.TableName}]`;

      setSelectedTables(prev =>
        e.target.checked
          ? [...prev, name]
          : prev.filter(t => t !== name)
      );
    }}
  />

  <Trash2
  onClick={() => {
    confirmAlert({
      title: 'Confirm Delete',
      message: `Are you sure you want to delete table "${table.TableName}"?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              const res = await fetch("https://utilities.livauto.com/api/droptable", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ tbl: `[aaaaall_temp].[dbo].[${table.TableName}]` })
              });
              const data = await res.json();
              if (data.status === "1") {
                setTables(prev => prev.filter(r => r.TableName !== table.TableName));
              }
            } catch (err) {
              console.log(err.message);
            }
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }}
  style={{ cursor: "pointer", width: "20px", height: "20px", color: "red" }}
/>
</td>
                <td style={{ 
                  border: "1px solid #ccc", 
                  padding: "10px",
                  fontWeight: "500"
                }}>
                  {table.TableName}
                </td>
                <td style={{ 
                  border: "1px solid #ccc", 
                  padding: "10px", 
                  textAlign: "right"
                }}>
                  {table.RecordCount.toLocaleString()}
                </td>
                {columnsArr.map((domain, domainIndex) => {
                  const count = getDomainCount(table, domain);
                  return (
                    <td 
                      key={domainIndex}
                      style={{ 
                        border: "1px solid #ccc", 
                        padding: "10px", 
                        textAlign: "right",
                        color: count > 0 ? "#333" : "#999"
                      }}
                    >
                      {count > 0 ? count.toLocaleString() : '-'}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
</div>
      {/* 📋 Table Selection Dropdown */}
      {tables.length > 0 && (
      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
          Select Table:
        </label>
        <select
          value={selectedTable}
          onChange={handleTableChange}
          style={{
            width: "250px",
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "16px",
            outline: "none",
          }}
        >
          <option value="">Select Table</option>
          {tables.map((table) => (
            <option key={table.TableName} value={table.TableName}>
              {table.TableName} ({table.RecordCount.toLocaleString()})
            </option>
          ))}
        </select>
      </div>
      )}

      {/* 📊 Email Domain Groups with Quantities */}
      {emailGroups.length > 0 && (
        <div style={{ marginBottom: "30px" }}>
                  <h3>
          Email Domain Groups <span style={{ fontSize: "16px", color: "#555", marginLeft: "10px" }}>
            (Total: {total})
          </span>
        </h3>

          <table
            style={{
              width: "100%",
              maxWidth: "400px",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f5f5f5" }}>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>Domain Group</th>
                <th style={{ border: "1px solid #ccc", padding: "8px" }}>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {emailGroups.map((group, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    {group.EmailDomainGroup}
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    <input
                      type="number"
                      min="0"
                      value={quantities[group.EmailDomainGroup] || 0}
                      onChange={(e) => handleQuantityChange(group.EmailDomainGroup, e.target.value)}
                      style={{
                        width: "100px",
                        padding: "4px 8px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        outline: "none",
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 🚀 Process Button */}


{tables.length > 0 && (
        <button
        onClick={handleProcess}
        disabled={loading || emailGroups.length === 0}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: emailGroups.length === 0 ? "#ccc" : "#007bff",
          color: "white",
          border: "none",
          borderRadius: "8px",
          cursor: emailGroups.length === 0 ? "not-allowed" : "pointer",
          opacity: loading ? 0.7 : 1,
        }}
      >
        {loading ? "Processing..." : "Process"}
      </button>
     )}

{tables.length === 0 && (
  <div className="text-center mt-4">
    <div className="spinner-border text-primary" role="status"></div>
    <p className="mt-2">Loading please wait...</p>
  </div>
)}


      {/* 📧 Dynamic Results Table */}
      {emails.length > 0 && (
        <div style={{ marginTop: "30px" }}>
          <p>
            <strong>Total Records:</strong> {emails.length}
          </p>

                {tables.length > 0 && (
      <div style={{ marginBottom: "20px" }}>
       <label
      style={{
        display: "block",
        marginBottom: "8px",
        fontWeight: "bold",
      }}
    >
      New Table Name:
    </label>
    <input
      type="text"
      value={newTableName}
      onChange={(e) => setNewTableName(e.target.value)}
      placeholder="Enter new table name"
      style={{
        width: "250px",
        padding: "8px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "16px",
        outline: "none",
      }}
    />
      </div>
      )}

          <button
            onClick={handleDownloadCSV}
            style={{
              marginBottom: "10px",
              padding: "8px 16px",
              fontSize: "14px",
              backgroundColor: "green",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            ⬇️ Download CSV
          </button>

          {/* 🧾 Table */}
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #ccc",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>#</th>
                  {Object.keys(emails[0]).map((col, i) => (
                    <th key={i} style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {col.toUpperCase()}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {emails.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      {rowIndex + 1}
                    </td>
                    {Object.keys(emails[0]).map((col, colIndex) => (
                      <td key={colIndex} style={{ border: "1px solid #ccc", padding: "8px" }}>
                        {row[col] !== null && row[col] !== undefined
                          ? row[col].toString().trim()
                          : ""}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Warmup;